import {
  AppointmentChangeStatus,
  AppointmentStatusChangeModal,
} from "@/components/appointment-status-change";
import { Box, Grid, Tooltip } from "@mui/material";
import { GridSortItem } from "@mui/x-data-grid";
import { cloneDeep } from "lodash";
import moment from "moment";
import "moment-timezone";
import { Suspense, useEffect, useMemo, useState } from "react";
import { Calendar, NavigateAction, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import ElevatedPaper from "../../../../components/ElevatedPaper";
import Flex from "../../../../components/Flex";
import { ScrollArea } from "../../../../components/ScrollBar";
import SideFilters from "../../../../components/SideFilter";
import SuccessModal, { useSuccess } from "../../../../components/SuccessModal";
import CustomTitle from "../../../../components/app/CustomTitle";
import ToolBar from "../../../../components/app/provider/scheduling/ToolBar";
import { PROVIDER_PATHS, appPaths } from "../../../../constants/paths";
import { AppointmentSchedulingType } from "../../../../dummy-data/appointment-list-data-scheduling";
// import { EVENT } from "../../../../dummy-data/scheduling-event";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import dayjs from "dayjs";
import ViewAppointment from "../../../../components/ViewAppointment";
import useCurrentUser from "../../../../hooks/local-storage/use-current-user";
import { useQueryParams } from "../../../../hooks/use-query-param";
import { useReduceDisclosure } from "../../../../hooks/use-reduce-disclosure";
import { useAppointmentsV2 } from "../../../../queries/patient-portal/forms/appointment/use-appointment-list-v2";
import { useGetAppointment } from "../../../../queries/use-get-appointment";
import { LocationControllerApi } from "../../../../services";
import {
  formatDateTime,
  getDateWithOffsetByMinusHr,
  getStartEndDateOfSameDay,
} from "../../../../utils/date-time-utility";
import lazyWithRetry from "../../../../utils/lazy-with-retry";
import { __type_builder } from "../../../../utils/type-builder";
import {
  DEFAULT_BORDER_COLOR,
  DEFAULT_NEUTRAL_TEXT_COLOR,
  DEFAULT_TEXT_COLOR,
  DEF_PAGINATION,
  DGT_Pagination,
  getConfigObject,
} from "../../../../utils/utils";
import InstantAppointMentModal from "./InstantAppointMentModal";
import NewAppointment from "./appointment/NewAppointment";
import RescheduleAppointment from "./appointment/RescheduleAppointment";
import {
  ALL_FILTER_OPTIONS,
  EventType,
} from "./availability/availability-contant";
import {
  SchedulingDayEventCard,
  ShowMoreDrawer,
  WeekEventCard,
  eventWrapper,
} from "./availability/scheduling-utils";
import {
  DAY_VIEW_STYLES,
  WEEK_VIEW_STYLES,
  getCalcFilterDate,
  getWeekStartAndEnd,
} from "./scheduling-constant";
import { getStoredRealm } from "@/utils/auth-storage";

const CheckIn = lazyWithRetry(() => import("./appointment/CheckIn"));

export type ViewType = "day" | "month" | "week";
export type ToolBarPropsType = {
  label: string;
  onNavigate: (navigate: NavigateAction) => void;
};

const SchedulingLayout = () => {
  const [selectedPatient, setSelectedPatient] = useState<{
    value: string;
    label: string;
  } | null>(null);
  const [me] = useCurrentUser();

  const [selectedAppointmentType, setSelectedAppointmentType] = useState<
    { value: string; label: string }[] | undefined
  >([]);

  const [selectedProvider, setSelectedProvider] = useState<
    { value: any; label: string; color: string }[] | undefined
  >([
    {
      value: me?.uuid || "",
      label: `${me?.firstName || ""} ${me?.lastName || ""}`,
      color: me?.colorCode || "fff",
    },
  ]);
  const localizer = momentLocalizer(moment);
  const [value, setValue] = useState("appointment");
  const dashboardStatus = useQueryParams("status")
    ?.split(",")
    ?.map((statusStr) => statusStr.trim());

  const getStatusFilterOption = (dashboardStatus: string[] | undefined) => {
    if (!dashboardStatus) return ALL_FILTER_OPTIONS["Status"];

    return {
      ...ALL_FILTER_OPTIONS["Status"],
      optList: ALL_FILTER_OPTIONS.Status.optList.map((status) => {
        return {
          ...status,
          selected: dashboardStatus.includes(status.value),
        };
      }),
      activeFilterCount: dashboardStatus.length,
    };
  };

  const [filterOptions, setFilterOptions] = useState<
    __type_builder<typeof ALL_FILTER_OPTIONS>
  >({
    ...ALL_FILTER_OPTIONS,
    Status: getStatusFilterOption(dashboardStatus),
  });
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [
    appointmentStatusChangeDisclosure,
    rescheduleDisclosure,
    appointmentDisclosure,
    checkInDrawer,
  ] = useReduceDisclosure(4);
  const [statusChangedTo, setStatusChangedTo] =
    useState<AppointmentChangeStatus>();
  const [selectedAppointment, setSelectedAppointment] =
    useState<AppointmentSchedulingType>();

  const [searchParams, setSearchParams] = useSearchParams();
  const filterDateType = searchParams.get("filterDateType") as ViewType | null;
  const [view, setView] = useState<ViewType>(filterDateType || "week");
  const location = useLocation();

  useEffect(() => {
    if (!searchParams.get("defaultFilter")) {
      setSearchParams(
        { defaultFilter: "true", filterDateType: "week" },
        { replace: true }
      );
      setView("week");
    }
  }, []);
  const isAvailability = location.pathname !== PROVIDER_PATHS.AVAILABILITY;
  //todo: get locations list API we need to use hook for this API.
  useEffect(() => {
    if (isAvailability) {
      getLocationsList();
    }
  }, [isAvailability]);

  function getLocationsList() {
    new LocationControllerApi(getConfigObject())
      .getLocation(
        "", //searchString
        getStoredRealm()! //xTENANTID
      )
      .then((resp: any) => {
        setFilterOptions({
          ...filterOptions,
          Locations: {
            ...ALL_FILTER_OPTIONS.Locations,
            optList:
              resp?.data?.data?.map((el: any) => {
                return {
                  value: el.uuid,
                  label: el.name,
                  selected: false,
                };
              }) ?? [],
          },
        });
      });
  }

  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);
  const { endTime, startTime } = getStartEndDateOfSameDay(dayjs(new Date()));
  const { sDate, eDate } = getWeekStartAndEnd(new Date() as any);
  const [filterDate, setFilterDate] = useState<[string, string]>([
    view === "day"
      ? (startTime ?? new Date()?.toISOString())
      : sDate?.toISOString(),
    view === "day"
      ? (endTime ?? new Date()?.toISOString())
      : eDate?.toISOString(),
  ]);
  // Date highlighted in the mini calendar; kept in sync with the main calendar.
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const isTableView = location.pathname?.includes(
    appPaths.schedulingAppointment
  );

  useEffect(() => calcFilterDate(view, new Date()), []);

  useEffect(() => {
    if (view === "month" && !isTableView) {
      setFilterOptions((prev: any) => {
        const copiedItem = cloneDeep(prev);
        copiedItem["Status"].optList = copiedItem["Status"].optList?.map(
          (it: any) => ({
            ...it,
            selected: true,
          })
        );
        copiedItem["Status"].isSelectAll = true;
        copiedItem["Status"].isExpand = false;

        return copiedItem;
      });
    }
  }, [isTableView]);

  const {
    data: appointmentsList,
    isLoading,
    isRefetching,
  } = useAppointmentsV2({
    disabled: !isAvailability || !filterDate[0] || !filterDate[1],
    startDate: filterDate[0],
    endDate: filterDate[1],
    pagination: !isTableView ? { page: 0, pageSize: 250 } : pagination, // todo: calnder view we are setting page size 250 but in table view we are setting page size 10.
    gridSorting,
    providerGroupId: getStoredRealm(),
    // appointmentType: filterOptions?.["Appointment Type"]?.optList
    //   ?.filter((loc: any) => loc.selected)
    //   ?.map((l: any) => l.value) as any,
    appointmentMode: filterOptions?.["Visit Type"]?.optList
      ?.filter((loc: any) => loc.selected)
      ?.map((l: any) => l.value) as any,
    appointmentStatus: filterOptions?.["Status"]?.optList
      ?.filter((loc: any) => loc.selected)
      ?.map((l: any) => l.value) as any,
    appStatusForPatient: ["CONFIRMED"],
    providerUuid: selectedProvider?.map((item) => item.value) ?? undefined,
    appointmentType:
      selectedAppointmentType?.map((item) => item.label) ?? (undefined as any),
    patientUuid: selectedPatient?.value ? [selectedPatient.value] : undefined,
    locationUuid: filterOptions.Locations.optList
      .filter((location: any) => location.selected)
      .map((location: any) => location.value),
  });

  const timezoneFormatedStartTime = (startTime: string) =>
    formatDateTime(startTime) ?? "";
  const timezoneFormatedEndTime = (endTime: string) =>
    formatDateTime(endTime) ?? "";

  const EVENT: EventType[] | undefined = useMemo(
    () =>
      appointmentsList?.data?.content?.map((it) => {
        return {
          title: `${it?.patientName}`,
          start: new Date(timezoneFormatedStartTime(it.startTime)),
          end: it?.endTime
            ? new Date(timezoneFormatedEndTime(it.endTime))
            : view === "month"
              ? new Date(
                  getStartEndDateOfSameDay(dayjs(it?.startTime))?.endTime as any
                )
              : null,
          status: it.status,
          mode: it?.mode,
          type: it?.type,
          patientName: it?.patientName,
          ...it,
        };
      }),
    [appointmentsList?.data?.content]
  );

  const calcFilterDate = (v?: ViewType, sDate?: Date) => {
    const nextFilterDate = getCalcFilterDate(filterDate, v, sDate, view);
    setFilterDate(nextFilterDate);

    // `filterDate[0]` is the start of the API range (1st of the month in month
    // view), so it cannot drive the mini calendar's highlight. Track the date
    // the user actually picked instead: an explicit pick/navigation wins, and a
    // plain view switch keeps the current selection as long as it still falls
    // inside the new range.
    setSelectedDate((prev) => {
      if (sDate) return sDate;

      const prevDay = dayjs(prev).startOf("day");
      const isInRange =
        !prevDay.isBefore(dayjs(nextFilterDate[0]).startOf("day")) &&
        !prevDay.isAfter(dayjs(nextFilterDate[1]).startOf("day"));

      return isInRange ? prev : new Date(nextFilterDate[0]);
    });
  };

  function toolBarComponent(props: ToolBarPropsType) {
    return (
      <ToolBar
        {...props}
        isCollapse={isCollapse}
        view={view}
        handleChangeView={(value: ViewType) => {
          calcFilterDate(value);
          setView(value);
          setSearchParams(
            (prev) => {
              prev.set("filterDateType", value);
              return prev;
            },
            { replace: true }
          );
        }}
        newAppointmentDisclosure={newAppointmentDisclosure}
        InstantAppointment={instantAppointmentDisclosure}
        onFilterClick={() => {
          setIsCollapse((prev) => !prev);
        }}
        selectedProviders={selectedProvider}
      />
    );
  }

  // function eventWrapper(props: any) {
  //   return (
  //     <Flex>
  //       <Box
  //         width={"5px"}
  //         sx={{
  //           aspectRatio: 2 / 3,
  //           clipPath: "ellipse(100% 85% at 0 50%)",
  //         }}
  //         bgcolor={"red"}
  //       />
  //       {props.children}
  //     </Flex>
  //   );
  // }

  const [showCalender, setShowCalender] = useState(true);

  const [isCollapse, setIsCollapse] = useState<boolean>(false);
  const [
    newAppointmentDisclosure,
    instantAppointmentDisclosure,
    showMoreDisclosure,
  ] = useReduceDisclosure(3);
  const [
    openedSuccessModal,
    { open: openSuccessModal, close: closeSucessModal },
  ] = useSuccess();

  const { data: AppointmentData } = useGetAppointment({
    appointmentUuid: selectedAppointment?.uuid,
    providerGroupId: getStoredRealm() ?? "",
  });
  // const eventPropGetter = (event, start, end, isSelected) => {
  //   return {
  //     borderRadius: "0px",
  //     height: "100px !important",
  //     opacity: 0.8,
  //     color: "white",
  //     border: "0px",
  //     display: "block",
  //   };
  // };

  const eventPropGetter = () => {
    return {
      style: {
        backgroundColor: "#FCD27F",
        color: "white",
      },
    };
  };

  const providerCount =
    selectedProvider?.filter((it) => it?.value)?.length || 0;

  const isMultipleProviders = providerCount > 1;

  const classShowMore = {
    ".rbc-event": {
      height: "56px",
      width: "96% !important",
    },
    ".rbc-show-more": {
      marginTop: "15px!important",
    },
  };

  return (
    <ElevatedPaper
      defaultSetting={false}
      sx={{
        padding: "10px 0px 10px 0px",
        // height: "auto",
        // maxHeight: "96vh",
        borderRadius: 0,
      }}
    >
      {/* <ScrollArea height={"calc(90.5vh)"}> */}
      <Grid container wrap="nowrap">
        <Grid
          item
          overflow={"visible"}
          sx={{
            width: isCollapse ? 0 : "240px",
            minWidth: isCollapse ? 0 : "240px",
            maxWidth: isCollapse ? 0 : "240px",
          }}
          display={!isAvailability ? "none" : isCollapse ? "none" : "unset"}
        >
          <Flex flexDirection={"column"}>
            {!isCollapse && (
              <Flex height={"40px"} mb={1}>
                <Flex
                  paddingLeft={"16px"}
                  display={"flex"}
                  alignItems={"center"}
                >
                  <Box
                    component="img"
                    src="/filter.svg"
                    sx={{
                      cursor: "pointer",
                      width: "15px",
                      height: "12px",
                      marginRight: "10.5px",
                    }}
                    onClick={() => setIsCollapse((prev) => !prev)}
                  />
                  <CustomTitle
                    sx={{ color: DEFAULT_TEXT_COLOR, cursor: "pointer" }}
                    onClick={() => setIsCollapse((prev) => !prev)}
                  >
                    Filters
                  </CustomTitle>
                  <Tooltip
                    title={showCalender ? "Hide Calendar" : "Show Calendar"}
                  >
                    <Flex
                      width={"100%"}
                      ml={1}
                      sx={{
                        cursor: "pointer",
                      }}
                      onClick={() => setShowCalender(!showCalender)}
                    >
                      {showCalender ? (
                        <VisibilityOffIcon
                          sx={{ color: DEFAULT_TEXT_COLOR }}
                          fontSize="small"
                        />
                      ) : (
                        <VisibilityIcon
                          sx={{ color: DEFAULT_TEXT_COLOR }}
                          fontSize="small"
                        />
                      )}
                    </Flex>
                  </Tooltip>
                </Flex>
              </Flex>
            )}

            {!isCollapse && isAvailability && (
              // <Grid item md={12} bgcolor={"yellow"}>
              <Box
                height={"calc(100vh - 141px)"}
                sx={{ borderRight: "1px solid " + DEFAULT_BORDER_COLOR }}
              >
                <ScrollArea height={"calc(100vh - 152px)"}>
                  <SideFilters
                    showCalender={showCalender}
                    view={view}
                    selectedDate={selectedDate}
                    handleDateChange={(val: any) => {
                      calcFilterDate(view, new Date(val));
                    }}
                    patient={selectedPatient}
                    provider={selectedProvider}
                    setPatient={setSelectedPatient}
                    setProvider={setSelectedProvider}
                    filterOptions={filterOptions}
                    setFilterOptions={setFilterOptions}
                    selectedAppointmentType={selectedAppointmentType}
                    setSelectedAppointmentType={setSelectedAppointmentType}
                  />
                </ScrollArea>
              </Box>
            )}
          </Flex>
        </Grid>
        {/* )} */}
        <Grid item xs sx={{ flex: 1, minWidth: 0, pl: !isCollapse ? 0 : 2 }}>
          {isAvailability && (
            <Box
              mr={1}
              sx={{
                ...(!isMultipleProviders ? classShowMore : {}),
                "& .rbc-header": {
                  backgroundColor: "white",
                  color: DEFAULT_NEUTRAL_TEXT_COLOR,
                },
                "& .rbc-event-label": { display: "none" },
                ...(isTableView && {
                  "& .rbc-month-view": {
                    display: "none",
                  },
                  "& .rbc-time-view": {
                    display: "none",
                  },
                }),
                ...(view === "week" && !isTableView && WEEK_VIEW_STYLES),
                ...(view === "day" && !isTableView && DAY_VIEW_STYLES),
              }}
            >
              <Calendar
                // offset of 30 minutes to the current time
                scrollToTime={getDateWithOffsetByMinusHr(new Date(), 0.5)}
                enableAutoScroll
                localizer={localizer}
                step={view === "day" || view === "week" ? 60 : 7.5}
                timeslots={view === "day" || view === "week" ? 1 : undefined}
                dayLayoutAlgorithm={
                  view === "day" || view === "week" ? "no-overlap" : undefined
                }
                events={EVENT}
                key={
                  isMultipleProviders
                    ? "multiple"
                    : isTableView
                      ? "tableView"
                      : "single"
                }
                startAccessor="start"
                endAccessor="end"
                date={filterDate[0]}
                view={view}
                onShowMore={showMoreDisclosure.open}
                onNavigate={(date) => calcFilterDate(view, date)}
                eventPropGetter={() => {
                  if (view === "day") {
                    return {
                      style: {
                        backgroundColor: "transparent",
                        borderRadius: 8,
                        color: "black",
                        maxWidth: "96%",
                        marginLeft: "2%",
                        marginBottom: "4px",
                        minHeight: "21px",
                        border: "none",
                        boxShadow: "none",
                        padding: 0,
                      },
                    };
                  }
                  return {
                    style: {
                      backgroundColor: isMultipleProviders
                        ? "white"
                        : "#F3F4F6",
                      borderRadius: 6,
                      color: "black",
                      width: "96%",
                      marginLeft: "2%",
                      marginBottom: "2px",
                      minHeight: "21px",
                      ...eventPropGetter(),
                    },
                  };
                }}
                style={{
                  height: isTableView ? undefined : "calc(100vh - 105px)",
                  fontFamily: "'Inter', sans-serif",
                }}
                onSelectEvent={(newSelectedAppointment) => {
                  appointmentDisclosure.open();
                  setSelectedAppointment(newSelectedAppointment as any);
                }}
                components={{
                  toolbar: toolBarComponent,
                  event: (props) =>
                    view === "day" ? (
                      <SchedulingDayEventCard props={props} />
                    ) : view === "week" ? (
                      <WeekEventCard props={props} />
                    ) : (
                      eventWrapper(props, view, isMultipleProviders)
                    ),
                }}
              />
            </Box>
          )}

          <ShowMoreDrawer
            disclosureHost={showMoreDisclosure}
            onEvenClick={(newSelectedAppointment) => {
              appointmentDisclosure.open();
              setSelectedAppointment(newSelectedAppointment as any);
            }}
            isMultipleProviders={isMultipleProviders}
          />

          {!isTableView && appointmentDisclosure.opened && (
            <ViewAppointment
              open={appointmentDisclosure.opened}
              onClose={appointmentDisclosure.close}
              activeTab={value}
              handleTabChange={(val) => setValue(val)}
              openChangeStatus={(statusChanged: AppointmentChangeStatus) => {
                appointmentStatusChangeDisclosure.open();
                setStatusChangedTo(statusChanged);
              }}
              openRescheduleAppointment={rescheduleDisclosure.open}
              openCheckIn={checkInDrawer.open}
              appointmentUuid={selectedAppointment?.uuid}
            />
          )}

          {checkInDrawer.opened && (
            <Suspense fallback={null}>
              <CheckIn
                disclosureHost={checkInDrawer}
                patientId={selectedAppointment?.patientId}
                appointmentUuid={selectedAppointment?.uuid}
              />
            </Suspense>
          )}

          {newAppointmentDisclosure.opened && (
            <NewAppointment
              opened={newAppointmentDisclosure.opened}
              onClose={newAppointmentDisclosure.close}
            />
          )}
          {instantAppointmentDisclosure.opened && (
            <InstantAppointMentModal
              disclosureHost={instantAppointmentDisclosure}
            />
          )}
          {openedSuccessModal && (
            <SuccessModal
              label={successMessage}
              opened={openedSuccessModal}
              onClose={closeSucessModal}
            />
          )}

          {rescheduleDisclosure.opened && (
            <RescheduleAppointment
              appointmentData={AppointmentData?.data}
              successHandler={(msg) => {
                openSuccessModal();
                setSuccessMessage(msg);
                appointmentStatusChangeDisclosure.close();
                rescheduleDisclosure.close();
              }}
              opened={rescheduleDisclosure.opened}
              onClose={rescheduleDisclosure.close}
            />
          )}
          <AppointmentStatusChangeModal
            disclosureHost={appointmentStatusChangeDisclosure}
            appointmentId={selectedAppointment?.uuid?.toString()}
            status={statusChangedTo}
            onSuccess={(message) => {
              appointmentDisclosure.close();
              openSuccessModal();
              setSuccessMessage(message);
            }}
          />

          {/* <ScrollArea height={"calc(100vh - 90px)"}> */}
          <Box pl={!isAvailability && !isCollapse ? "14px" : 0} height={"100%"}>
            <Outlet
              context={{
                selectedAppointment: selectedAppointment,
                appointmentsList,
                pagination,
                setPagination,
                setGridSorting,
                gridSorting,
                view,
                setSelectedAppointment: setSelectedAppointment,
                openChangeStatus: (statusChanged: AppointmentChangeStatus) => {
                  appointmentStatusChangeDisclosure.open();
                  setStatusChangedTo(statusChanged);
                },
                openReschedule: rescheduleDisclosure.open,
                appointmentDisclosure: isTableView
                  ? appointmentDisclosure
                  : undefined,
                isLoading: isLoading || isRefetching,
              }}
            />
          </Box>
          {/* </ScrollArea> */}
        </Grid>
      </Grid>

      {/* <SideDrawer open={openedScheduleDrawer} onClose={closeScheduleDrawer} /> */}
      {/* </ScrollArea> */}
    </ElevatedPaper>
  );
};

export default SchedulingLayout;
